module.exports = __webpack_public_path__ + "static/nz_digital_wallet-google-pay-phone-f378e1bd500e5ad53795a4a1dcad59c3.png";